// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3PvEP","requiredAsterisk":"Info_requiredAsterisk__3Y9os"};